export const QUEST_COMPLETE_ANIMATION_DELAY = 4000;
